/** 乘法精度丢失一分 test
 * @param {*}  arg1 数值 arg2 100 列如：0.009,100 返回0.9
 */
export function floatMultiply(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
}

export const formatDecimal = (num, decimal) => {
  num = num.toString();
  let index = num.indexOf('.');
  if (index !== -1) {
    num = num.substring(0, decimal + index + 1);
  } else {
    num = num.substring(0);
  }
  return parseFloat(num).toFixed(decimal);
};
/**
 *
 */
export const debounce = (fn, duration = 200) => {
  let timer = null;
  return function() {
    let that = this, // this对象
      args = arguments; // 参
    clearTimeout(timer);
    timer = setTimeout(() => {
      that[fn](...args); // vue用法
    }, duration);
  };
};
/**
 * 加减法
 * @param {*} arr
 * @returns
 */
export function countSum(arr) {
  if (!arr.length) return 0;
  arr = arr.map((v) => {
    if (v && !Number.isNaN(Number(v))) return Math.round(v * 100);
    return 0;
  });
  const result = arr.reduce((prev, curr) => {
    return prev + curr;
  }, 0);
  return result / 100;
}

/** 除法
 * @param { number } num1
 * @param { number } num2
 */
export function division(num1, num2) {
  let t1, t2, r1, r2;
  try {
    t1 = num1.toString().split('.')[1].length;
  } catch (e) {
    t1 = 0;
  }
  try {
    t2 = num2.toString().split('.')[1].length;
  } catch (e) {
    t2 = 0;
  }
  r1 = Number(num1.toString().replace('.', ''));
  r2 = Number(num2.toString().replace('.', ''));
  return (r1 / r2) * Math.pow(10, t2 - t1);
}

// 图片url 转base64
export const toBase64URL = (url) =>
  fetch(url, { mode: 'no-cors' })
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
//获取枚举列表
export function getEnumObj(list, key = 'value') {
  let obj = {};
  let arr = list.map((item) => item[key]);
  arr.forEach((item) => {
    obj[item] = item;
  });
  return obj;
}

// 判断时间d1是否大于时间d2
export function compareDate(d1, d2) {
  return new Date(d1.replace(/-/g, '/')) > new Date(d2);
}

// 过滤对象的部分属性并返回新的对象
export function filterObjKeys(obj, keys) {
  return Object.keys(obj)
    .filter((key) => keys.includes(key))
    .reduce((result, key) => {
      result[key] = obj[key];
      return result;
    }, {});
}

// 获取货币单位
export function getUnit(countryCode) {
  switch (countryCode) {
    case 'CZ':
      return 'Kč';
    case 'PL':
      return 'zł';
    case 'SE':
      return 'kr';
    case 'GB':
      return '£';
    default:
      return '€';
  }
}

// 获取币种
export function getCurrency(countryCode) {
  switch (countryCode) {
    case 'CZ':
      return 'CZK';
    case 'PL':
      return 'PLN';
    case 'SE':
      return 'SEK';
    case 'GB':
      return 'EUR';
    default:
      return 'EUR';
  }
}
// 获得文件后缀
export function getFileSuffixName(value) {
  if (!value) return;
  return value.substring(value.lastIndexOf('.') + 1);
}
// 获取链接中的文件名
export function getNameByUrl(url = '') {
  url = `${url}`;
  let urlSplit = url.split('/');
  return urlSplit[urlSplit.length - 1].split('.')[0];
}

export async function downloadFileByUrl(url, newFileName) {
  url = url.replace('http://', 'https://');
  const blob = await getBlob(url);
  let suffix = url
    .split('.')
    .pop()
    .toLowerCase();
  saveAs(blob, newFileName + '.' + suffix);

  // 将文件路径转为blob
  function getBlob(url) {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response);
        }
      };
      xhr.send();
    });
  }
  function saveAs(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const anchor = document.createElement('a');
      const body = document.querySelector('body');
      anchor.href = window.URL.createObjectURL(blob);
      anchor.download = filename;
      anchor.style.display = 'none';
      body.appendChild(anchor);
      anchor.click();
      body.removeChild(anchor);
      window.URL.revokeObjectURL(anchor.href);
    }
  }
}

/**
 * 获取当前规格可选属性
 */
export function getAvailableAttrs(product, selectedAttrs = [], checkStock = false) {
  if (!product || !product.productInfoAttributeRelationDTOList || !product.productSpecsDTOList) {
    return [];
  }

  const primeNumbers = [
    2,
    3,
    5,
    7,
    11,
    13,
    17,
    19,
    23,
    29,
    31,
    37,
    41,
    43,
    47,
    53,
    59,
    61,
    67,
    71,
    73,
    79,
    83,
    89,
    97,
    101,
    103,
    107,
    109,
    113,
    127,
    131,
  ];
  const getPrime = (id) => {
    const index = product.productInfoAttributeRelationDTOList.findIndex((a) => a.productAttributeId === id);
    return primeNumbers[index];
  };
  const hash = (attrIds) => {
    return attrIds.reduce((prev, cur) => prev * getPrime(cur), 1);
  };

  // 获得所有可用规格的质数乘积hash
  const specsHashes = product.productSpecsDTOList
    .filter((p) => !checkStock || p.flashStock)
    .map((p) => hash(p.productSpecsAttributeIdList));

  // 过滤出存在可被该属性和已选的非同类属性整除的规格hash的属性
  const res = product.productInfoAttributeRelationDTOList
    .filter((a) => {
      const selectedIds = selectedAttrs
        .filter((s) => s.attributeTypeId !== a.attributeTypeId && s.subProductCategoryId === a.subProductCategoryId)
        .map((s) => s.productAttributeId);

      return specsHashes.some((h) => {
        return h % hash([...selectedIds, a.productAttributeId]) === 0;
      });
    })
    .map((a) => a.productAttributeId);

  return res;
}

export function getPaymethodIcon(key) {
  if (['UNIONPAY', 'AIRWALLEX_CARD'].includes(key.toUpperCase())) {
    return 'https://static.xyb2b.com/images/15958b2ccb9727f9f953c7246eb32322.svg';
  }
  if (key.toLowerCase().match(/alipay/)) {
    return 'https://static.xyb2b.com/images/d59393e0270af442ec35204676d5ef98.svg';
  }
  if (key.toLowerCase().match(/wechat|weixin/)) {
    return 'https://static.xyb2b.com/images/113e0a2e01139d2aa6c1a1bf23c2c605.svg';
  }
  if (key.toLowerCase().match(/ebank/)) {
    return 'https://static.xyb2b.com/images/0ecac4dccb0f4b8b67ea0ce0672329e0.svg';
  }
  return 'https://static.xyb2b.com/images/39b3f7b3beda9d60c4f507b1ad0c917c.svg';
}



// WEBPACK FOOTER //
// ./xcloud-client-components-web/utils/util.js